import turboInit from "../utils/turbo-init"

// Moves focus to a form's error summary after a failed submit.
//
// `role="alert"` is enough for a summary injected into a page that is already
// loaded, but after a full page reload screen readers do not reliably announce
// a role that was already in the DOM when the page arrived. Focusing the
// summary reads it out and puts the user at the start of what they need to fix
// instead of back at the top of the page.
turboInit(() => {
  const summaryEl = document.querySelector(`.js--form-error-summary`)
  if (!summaryEl) return

  // Not while the user is already working in a field – that happens when a
  // summary is rendered into a live page, where `role="alert"` does the job.
  if (document.activeElement && document.activeElement.closest(`form`)) return

  summaryEl.focus({ preventScroll: false })
})
